<app-chat-card
  class="coming-soon-card"
  [header]="'Write Your Way, Bru! (Coming Soon)'"
  [description]="
    'Choose custom writing styles and tones to match your needs—formal essays, creative stories, or casual notes. Perfect writing, every time.'
  "
  [route]="'/chat'"
>
</app-chat-card>
